<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link v-if="auth.user.is_admin" class="text-blue-400 hover:text-blue-600" href="/users">Users</Link>
        <span class="text-blue-400 font-medium">/</span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      <img v-if="user.photo" class="block ml-4 w-8 h-8 " :src="user.photo" />
    </div>
    <trashed-message v-if="user.deleted_at && auth.user.is_admin" class="mb-6" @restore="restore"> This user has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white  shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="First name" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Last name" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" type="tel" label="Phone" mask="(###) ###-####" placeholder="Phone number" name="phone" />
          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Password" />
          <select-input v-if="auth.user.is_admin" v-model="form.role" :error="form.errors.role" class="pb-8 pr-6 w-full lg:w-1/2" label="Role">
            <option v-for="role in roles" :key="role.value" :value="role.value"> {{ role.key }}</option>
          </select-input>
          <select-input v-if="auth.user.is_admin" v-model="form.custom_run" :error="form.errors.custom_run" class="pb-8 pr-6 w-full lg:w-1/2" label="Custom Run">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </select-input>
          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" />
          <select-input v-if="auth.user.is_admin" v-model="form.company" :error="form.errors.company" class="pb-8 pr-6 w-full" label="Company" @change="form.teams = []">
            <option value="null" disabled selected>Choose a company</option>
            <option v-for="c in companies" :key="c.id" :value="c.id"> {{ c.name }}</option>
          </select-input>
          <div v-if="auth.user.is_admin" class="w-full mb-4">
            <label class="form-label text-bold">Teams</label>
            <div class="grid grid-cols-4">
              <div v-for="team in company.teams" :key="team.id">
                <input v-model="form.teams" type="checkbox" :value="team.id" />
                <span class="text-sm px-2">{{ team.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="! user.deleted_at && auth.user.is_admin" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete User</button>
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Update User</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    auth     : Object,
    user     : Object,
    companies: Object,
    roles    : Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method   : 'put',
        first_name: this.user.first_name,
        last_name : this.user.last_name,
        email     : this.user.email,
        phone     : this.user.phone,
        password  : '',
        role     : this.user.role,
        custom_run: this.user.custom_run,
        company   : this.user.company,
        photo     : null,
        teams     : this.user.teams,
      }),
    }
  },
  computed:{
    company() {
      if (this.form.company) {
        return this.companies.find(c => c.id == this.form.company)
      }

      return {}
    },
  },
  methods: {
    update() {
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(`/users/${this.user.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(`/users/${this.user.id}/restore`)
      }
    },
  },
}
</script>
